
import { Box, Typography } from "@mui/material";
import React from "react";
import { Plans } from "../../common/const";
import moment from "moment";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";

const CurrentPlan = () => {
    const activePlan = Plans.find((a) => a.isActive);
    if (!activePlan) {
        return (
            <Box
                sx={{
                    background: 'white',
                    borderRadius: 2,
                    padding: 2,
                    textAlign: 'center'
                }}
            >
                <img src="/Images/NoActivePlan.png" alt="NoActivePlan" />
                <Typography fontWeight={600} fontSize={17}>No Active Plan</Typography>
                <Typography fontSize={15} color={theme.palette.background.dark}>Your free plan is expiring soon, get benefits of our plans, explain about the plan.</Typography>
                <CommonButton
                    label="Subscribe a Plan(Gold/Platinum/Diamond)"
                    marginBottom="0px"
                    height="30px"
                    marginTop={2}
                />
            </Box>
        );
    }

    // Calculate days difference
    const deadlineDate = moment(activePlan.date);
    const currentDate = moment();
    const daysDifference = deadlineDate.diff(currentDate, 'days');

    return (
        <Box
            sx={{
                background: theme.palette.plan[activePlan.name] || theme.palette.primary.main,
                borderRadius: 2,
                padding: 2
            }}
        >
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={1}
            >
                <Box>
                    <Typography fontWeight={600} fontSize={24} color="#D08700">
                        {activePlan.name}
                    </Typography>
                    <Typography color={theme.palette.background.dark}>
                        Your Plan
                    </Typography>

                    {/* Show days left or expiry date */}
                    <Box mt={1}>
                        {daysDifference > 0 ? (
                            <Typography variant="body2" color="error.main">
                                Expire in {daysDifference} days
                            </Typography>
                        ) : daysDifference === 0 ? (
                            <Typography variant="body2" color="error.main">
                                Expires today!
                            </Typography>
                        ) : (
                            <Typography variant="body2" color="error.main">
                                Expired {Math.abs(daysDifference)} days ago
                            </Typography>
                        )}
                    </Box>
                    <Typography variant="body2" color="background.dark" mt={1}>Enjoy premium features to boost your planning experience.</Typography>
                </Box>

                <img
                    src={`/Images/gold-bars.png`}
                    alt="subscription-logo"
                    style={{ objectFit: 'contain' }}
                />
            </Box>
            <CommonButton
                label="Upgrade to Platinum/Diamond"
                marginBottom="0px"
                height="30px"
            />
        </Box>
    );
}

export default CurrentPlan;